import { billingAndShippingAddressStyles } from "@insite/content-library/Widgets/CheckoutReviewAndSubmit/BillingAndShippingInfo";
import merge from "lodash/merge";
import { css } from "styled-components";

merge(billingAndShippingAddressStyles, {
    carrierGridItem: {
        css: css`
            display: none;
        `,
    },
    shippingServiceGridItem: {
        css: css`
            display: none;
        `,
    },
    deliveryDateGridItem: {
        width: 12,
    },
});
